import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=ca59836c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca59836c')) {
      api.createRecord('ca59836c', component.options)
    } else {
      api.reload('ca59836c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=ca59836c&", function () {
      api.rerender('ca59836c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z2F5L93I5LCO/JS/comp/childrenage.vue"
export default component.exports